import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Tooltip} from "reactstrap";
import {FormattedMessage} from "react-intl";

class ButtonExcludedFromRotate extends Component{
  constructor(props) {
    super(props);
    this.state = {
      tooltipExcludedFromRotate: false,
      excludedFromRotate: props.row.excludedFromRotate
    };

    this.onClick = this.onClick.bind(this);
  }

  toggleTooltip(){
    this.setState({
      tooltipExcludedFromRotate: !this.state.tooltipExcludedFromRotate
    });
  }

  onClick() {
    this.setState({...this.state, excludedFromRotate: !this.state.excludedFromRotate});
    this.props.toggleOption('excludedFromRotate');
  }

  render() {
    const {row} = this.props;
    const {tooltipExcludedFromRotate, excludedFromRotate} = this.state;

    return (
      <a id={'excludedFromRotate-' + row.id + '-row'} className={"fas fa-random ml-2" + (excludedFromRotate ? " text-primary" : "")} onClick={this.onClick}>
        <Tooltip
          delay={0}
          placement="top"
          isOpen={tooltipExcludedFromRotate}
          target={'excludedFromRotate-' + row.id + '-row'}
          toggle={() => this.toggleTooltip()}
        >
          <FormattedMessage id="rows.excludedFromRotate.button.tooltip"/>
        </Tooltip>
      </a>
    )
  }
}

ButtonExcludedFromRotate.propTypes = {
  row: PropTypes.shape({
    id: PropTypes.number.isRequired,
    excludedFromRotate: PropTypes.bool.isRequired,
  }).isRequired,
  toggleOption: PropTypes.func.isRequired
};

export default ButtonExcludedFromRotate;